import * as styles from './findings-count-label.css.ts'

type FindingsCountLabelProps = {
  count?: number
}

export const FindingsCountLabel: React.FC<FindingsCountLabelProps> = ({ count }) => {
  return (
    <div className={styles.container}>
      <span className={styles.label}>All findings</span>
      {count !== undefined && <span className={styles.count}>({count})</span>}
    </div>
  )
}
